// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"630":"d4ad233efeb1d959420253442063e6db7488fdeb","678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"630":"e5653d0194ad0c018b0c","678":"190480d3b82752410550","682":"d2cb1808309b3c2a3093","883":"c640f016364537c117c1"}[chunkId] + ".js";
};